/* eslint-disable import/prefer-default-export */
export const truncateText = (text, maxLength) => {
  if (text.length > maxLength) {
    return `${text.substring(0, maxLength)}...`;
  }
  return text;
};

export const numberWithCommas = (num) => num && Number(num).toLocaleString();
